import React from 'react';
import './Toggle.scss';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  leftLabel?: string;
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
  className?: string;
}

const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  label,
  leftLabel,
  size = 'md',
  disabled = false,
  className = '',
}) => {
  const sizeClasses = {
    sm: 'checkbox-wrapper-7-sm',
    md: 'checkbox-wrapper-7',
    lg: 'checkbox-wrapper-7-lg',
  };

  const toggleId = `toggle-${Math.random()}`;

  // Inline styles to ensure toggle appearance
  const toggleStyles = {
    position: 'relative' as const,
    display: 'inline-block',
  };

  const inputStyles = {
    display: 'none',
    appearance: 'none' as const,
    WebkitAppearance: 'none' as const,
    MozAppearance: 'none' as const,
  };

  const labelStyles: React.CSSProperties = {
    outline: '0',
    display: 'block',
    width: size === 'sm' ? '3em' : size === 'lg' ? '5em' : '4em',
    height: size === 'sm' ? '1.5em' : size === 'lg' ? '2.5em' : '2em',
    position: 'relative',
    cursor: 'pointer',
    userSelect: 'none',
    background: checked ? '#6C3EB8' : '#fbfbfb',
    borderRadius: '2em',
    padding: '2px',
    transition: 'all 0.4s ease',
    border: '1px solid #6C3EB8',
    boxSizing: 'border-box',
    margin: '0',
  };

  const thumbStyles: React.CSSProperties = {
    position: 'relative',
    display: 'block',
    content: '""',
    width: '50%',
    height: '100%',
    left: checked ? '50%' : '0',
    borderRadius: '2em',
    background: '#fff',
    transition: 'left 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    boxShadow: '0 0 0 1px rgba(108, 62, 184, 0.1), 0 4px 0 rgba(108, 62, 184, 0.08)',
  };

  return (
    <div
      className={`${sizeClasses[size]} ${className}`}
      style={{ ...toggleStyles, display: 'flex', alignItems: 'center' }}
    >
      {leftLabel && (
        <span style={{ marginRight: '1em', fontWeight: 600, color: !checked ? '#6C3EB8' : 'var(--vz-gray-700)' }}>
          {' '}
          {leftLabel}
        </span>
      )}
      <input
        className="tgl tgl-ios"
        type="checkbox"
        id={toggleId}
        checked={checked}
        onChange={e => !disabled && onChange(e.target.checked)}
        disabled={disabled}
        style={inputStyles}
      />
      <label className="tgl-btn" htmlFor={toggleId} style={labelStyles}>
        <span style={thumbStyles} />
      </label>
      {label && (
        <span style={{ marginLeft: '1em', fontWeight: 600, color: checked ? '#6C3EB8' : 'var(--vz-gray-700)' }}>
          {' '}
          {label}
        </span>
      )}
    </div>
  );
};

export default Toggle;
